/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_BackInputs */

const cs_templates_back = /** @type {(inputs: Templates_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na šablony`)
};

const en_templates_back = /** @type {(inputs: Templates_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to templates`)
};

/**
* | output |
* | --- |
* | "Back to templates" |
*
* @param {Templates_BackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_back = /** @type {((inputs?: Templates_BackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_BackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_back(inputs)
	return cs_templates_back(inputs)
});